import React from 'react';

const NotificationContainer = ({ notifications, onClose }) => {
  return (
    <div className="fixed top-20 right-4 w-64 bg-white rounded-lg shadow-lg overflow-hidden z-50">
      <div className="p-2 bg-blue-500 text-white flex justify-between items-center">
        <h3 className="font-bold text-md">Notifications</h3>
      </div>
      <div className="max-h-64 overflow-y-auto">
        {notifications.map((notification) => (
          <div key={notification.id} className="p-2 border-b hover:bg-gray-100">
            <p className="text-gray-800 text-sm">{notification.message}</p>
            <button onClick={() => onClose(notification.id)} className="text-red-500 text-xs mt-1 hover:text-red-700">
              Dismiss
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationContainer;
